function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import * as selectors from '../../selectors';
import messages from '../../messages';
const Header = ()=>{
    const resetPasswordType = useSelector(selectors.resetPasswordType);
    const verifiedSignatureToken = useSelector(selectors.verifiedSignatureToken);
    let messageKey;
    if (verifiedSignatureToken) {
        messageKey = 'setNewPassword';
    } else {
        messageKey = resetPasswordType !== 'email' ? 'resetPassword' : 'resetPasswordSent';
        if (resetPasswordType === 'code') {
            messageKey = 'enterCode';
        }
    }
    return /*#__PURE__*/ _jsx("header", {
        className: "pageHeader",
        children: /*#__PURE__*/ _jsx("h1", {
            className: "text--h2",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers[messageKey]))
        })
    });
};
export default Header;
